export const defaultSnapshot = '?x-oss-process=video/snapshot,t_3000,f_jpg,w_768';
export const defaultSnapshotTimer = '?x-oss-process=video/snapshot,t_2500,f_jpg,w_768';

export function GetQueryString(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}

// absoluteUrl 把站内相对路径转成绝对地址。
// 后端返回的资源地址是 /storage/... 这样的相对路径，浏览器同源访问即可；
// 但传给咪咕平台（如发布作品）的地址必须能被对方服务器访问，需要绝对 URL。
export function absoluteUrl(path) {
  if (!path) return path;
  if (path.indexOf('http://') === 0 || path.indexOf('https://') === 0) return path;
  return window.location.origin + (path.charAt(0) === '/' ? path : '/' + path);
}

export function publishMg(params) {
  const uid = sessionStorage.getItem('uid') ?? ''
  const secret = sessionStorage.getItem('secret') ?? ''
  const watermarkId = sessionStorage.getItem('watermarkId') ?? ''
  const projectId = sessionStorage.getItem('projectId') ?? ''
  const otherSet = sessionStorage.getItem('otherSet') ?? ''
  const releaseId = sessionStorage.getItem('releaseId') ?? ''
  const isMiniPublish = sessionStorage.getItem('isMiniPublish') ?? ''
  const url = `https://y.migu.cn/app/v5/p/publish-mid/index.html?videoUrl=${encodeURIComponent(params.video)}&videoCover=${encodeURIComponent(params.cover)}&uid=${uid}&secret=${secret}&watermarkId=${watermarkId}&projectId=${projectId}&otherSet=${otherSet}&releaseId=${releaseId}&isMiniPublish=${isMiniPublish}`
  window.location.href = url
}
export function fakeProgressBar(duration, callback) {
  const steps = duration; // 总更新次数
  const interval = 1000; // 每秒更新一次
  let currentStep = 0; // 当前步骤
  let progress = 0; // 当前进度

  const timer = setInterval(() => {
      currentStep++;

      // 随机生成进度增量，确保进度递增并最终达到 1
      const remainingSteps = steps - currentStep;
      const increment = remainingSteps > 0
          ? Math.random() * (1 - progress) / remainingSteps // 根据剩余步数动态调整增量范围
          : 1 - progress; // 最后一步直接达到 1

      progress = Math.min(progress + increment, 1); // 确保 progress 不超过 1

      // 调用回调函数，传递当前进度
      callback(progress);

      // 如果达到最大步数，清除定时器
      if (currentStep >= steps || progress >= 1) {
          clearInterval(timer);
      }
  }, interval);
}